// @flow

import styled, { css } from 'styled-components';
import { media } from '../../../../helpers';
import { Select } from '../../../form';
import type { Theme } from '../../../../types';

const StyledSelect = styled<typeof Select, Theme>(Select)`
  ${media.lg(css`
    display: none;
  `)}
`;

export default StyledSelect;
